(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('filter', filter);

    filter.$inject = [];

    function filter() {
        
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/views/directives/filter.html',
            scope: {
                field: '@',
                display: '@',
                type: '@', // 'string','number','date','options'
                ngModel: '=',
                ngChange: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            
            scope.operators = {
                string: [
                    {nombre:'E', id:'E', desc:'Empieza por...'},
                    {nombre:'=', id:'=', desc:'Igual a...'},
                    {nombre:'⊂', id:'⊂', desc:'Contiene...'}
                ],
                number: [
                    {nombre:'<', id:'<', desc:'Menor que...'},
                    {nombre:'>', id:'>', desc:'Mayor que...'},
                    {nombre:'=', id:'=', desc:'Igual a...'}
                ]
            };
            scope.showOperator = scope.type === 'string' || scope.type === 'number';

            scope.dateOpts = [
                {nombre: 'Personalizado', id:'custom'},
                {nombre: 'Hoy', id:'hoy'},
                {nombre: 'Ayer', id:'ayer'},
                {nombre: 'Esta semana', id:'week'},
                {nombre: 'Últimos 7 días', id:'last7'},
                {nombre: 'La semana pasada', id:'lastWeek'},
                {nombre: 'Este mes', id:'month'},
                {nombre: 'Últimos 30 días', id:'last30'},
                {nombre: 'El mes pasado', id:'lastMonth'},
                {nombre: 'Este año', id:'year'}
            ];
            if (!scope.ngModel.date) { scope.ngModel.date = { selected: null }; }
            
            if(!scope.ngModel.operator){
                if(scope.type === 'number'){
                    scope.ngModel.operator = {
                        id : '='
                    };
                } else if(scope.type === 'string'){
                    scope.ngModel.operator = {
                        id : 'E'
                    };
                }
            }
            
            scope.dateTypeChanged = function(){ 
                /* jshint maxcomplexity: false */
                if(!scope.ngModel.date.selected){ return; } 
                
                var today = Date.NewDate();
                switch(scope.ngModel.date.selected.id){ 
					case 'hoy':
                        scope.ngModel.input1 = 
                            new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                        scope.ngModel.input2 = new Date(today.getFullYear(), 
                            today.getMonth(), 
                            today.getDate() + 1, 
                            0, 0, 0);                               
                        break;
                    case 'ayer':
                        scope.ngModel.input1 = 
                            new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0);
                        scope.ngModel.input2 = 
                            new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                        break;
                    case 'week':
                        scope.ngModel.input1 = new Date(
                            today.getFullYear(), 
                            today.getMonth(),
                            today.getDate() - (today.getDay()-1),
                            0, 0, 0);
                        scope.ngModel.input2 = new Date(
                            today.getFullYear(), 
                            today.getMonth(),
                            today.getDate() - (today.getDay()-1) + 7,
                            0, 0, 0);
                        break;
                    case 'last7':
                        scope.ngModel.input1 = 
                            Date.NewDate(); scope.ngModel.input1.setDate(scope.ngModel.input1.getDate() - 7);
                        scope.ngModel.input2 = today;
                        break;
                    case 'lastWeek':
                        scope.ngModel.input1 =
                            new Date(today.getFullYear(), today.getMonth(),
                                today.getDate() - (today.getDay()-1) - 7, 0, 0, 0);
                        scope.ngModel.input2 =
                        new Date(today.getFullYear(), today.getMonth(),
                            today.getDate() - (today.getDay()-1), 0, 0, 0);
                        break;
                    case 'month':
                        scope.ngModel.input1 = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
                        scope.ngModel.input2 = new Date(today.getFullYear(), today.getMonth()+1, 1, 0, 0, 0);
                        break;
                    case 'last30':
                        scope.ngModel.input1 = Date.NewDate(); 
                        scope.ngModel.input1.setDate(scope.ngModel.input1.getDate() - 30);
                        scope.ngModel.input2 = today;
                        break;
                    case 'lastMonth':
                        scope.ngModel.input1 =  new Date(today.getFullYear(), today.getMonth() - 1, 1, 0, 0, 0);
                        scope.ngModel.input2 = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
                        break;
                    case 'year':
                        scope.ngModel.input1 = new Date(today.getFullYear(), 0, 1, 0, 0, 0);
                        scope.ngModel.input2 = new Date(today.getFullYear()+1, 0, 1, 0, 0, 0);
                        break; 

                }

                scope.filterChange();
            };

            scope.dateChanged = function(){
                if(scope.ngModel.date.selected && scope.ngModel.date.selected.id === 'custom') {
                    scope.filterChange();
                }
            };

            scope.filterChange = function(){
                scope.ngChange();
            };
        }
    }
})();